import {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';
import { SpriteSvg, SpriteSvgType } from '../../../../components/sprite-svg';
import { Navigate } from '../navigate';
import { NavigateItem } from '../navigate/item';
import './style.scss';
import { getProjectDocSearch, postFeedback } from '../../../../api/document';
import {
  // IProjectDocSearch,
  IProjectSearchListItem,
} from '../../../../model/api-modules/document';
import { debounce, escapeRegExp } from 'lodash';
import { getDocumentParams } from '../../../document/utils';
import { getArea } from '../../../utils/env';
import getFormatMessage from '../../../../locales/get-format-message';
// import * as Segmentit from 'segmentit';
import { Segment, useDefault } from 'segmentit';
import { Drawer } from 'antd';
import closeIcon from '../../../../assets/svg/close-icon.svg';
import { useHistory } from 'react-router-dom';
import { connectPostSSE } from '../../../../lib/http/connect-sse';
// import { sseStreamRequest } from '../../../../lib/http/sse';
// import { getLoginToken } from '../../../lib';
import MarkdownIt from 'markdown-it';
import hiddenAi from '../../../../assets/svg/hidden-ai.svg';
import loadingAi from '../../../../assets/images/upload-loading-icon.png';
import aiIcon from '../../../../assets/svg/ai-icon.svg';
import aiLogo from '../../../../assets/svg/ai-logo.svg';
import downIcon from '../../../../assets/svg/down-icon-black.svg';
import refreshIcon from '../../../../assets/svg/refresh.svg';
import pauseIcon from '../../../../assets/svg/pause-icon.svg';
import classNames from 'classnames';
import { SvgIcon } from '../../svg-icon';
import { SvgIconName } from '../../svg-icon/model';
import copy from 'copy-to-clipboard';
import { messageSuccess } from '../../../../components/message';
import { DeployArea, LanguageType } from '../../../../model';
import { LanguageType as Lang } from '../../../../lib';
import { useSelector } from 'react-redux';
import { IRootState } from '../../../../store/reducers';
import { getConfig } from '../../../../config';
import loadingIcon from '../../../../assets/svg/loading-icon.svg';
import successIcon from '../../../../assets/svg/success-circle-fill.svg';
import { isMobile } from '../../../../lib/mobile';
import emptyIcon from '../../../../assets/img/empty.png';

interface IProps {
  // readonly visible: boolean;
  readonly onClose: () => void;
  readonly isDocPublicRoute: boolean;
  readonly searchValue: string;
  readonly isOpenDrawer: boolean;
  readonly lang: LanguageType | null;
}

let segment: any = null;

export const SearchContent = forwardRef((props: IProps, ref) => {
  // useDefault(segment);
  const query = getDocumentParams();
  const [searchValue, setSearchValue] = useState<string>('');
  const [idx, setIdx] = useState<number>(-1);
  const [loading, setLoading] = useState<boolean>(false);
  const [result, setResult] = useState<ReadonlyArray<IProjectSearchListItem>>(
    []
  );
  const [segmetValue, setSegmetValue] = useState<string[]>([]);
  // const [aiContent, setAiContent] = useState<string>('');
  // const [aiLoading, setAiLoading] = useState<boolean>(false);
  const [isThink, setIsThink] = useState<boolean>(false); // 当前是否在思考中
  const [timeCount, setTimeCount] = useState<number>(0); // 思考时间
  const [isShowThink, setIsShowThink] = useState<boolean>(true); // 是否展示思考内容
  const [isGenerating, setIsGenerating] = useState<boolean>(false);
  const [isStop, setIsStop] = useState<boolean>(false);
  const [isLike, setIsLike] = useState<boolean>(false);
  const [isFeedback, setIsFeedback] = useState<boolean>(false);
  const [isShowAi, setIsShowAi] = useState<boolean>(true);
  const [referenceDoc, setReferenceDoc] = useState<any[]>([]);
  const [currentSSE, setCurrentSSE] = useState<{ close: () => void } | null>(
    null
  );
  const [showMcp, setShowMcp] = useState<boolean>(false);
  const [isMcpLoding, setIsMcpLoding] = useState<boolean>(false);
  const navigateRef = useRef<HTMLDivElement>(null);
  const visible = props.isOpenDrawer;
  const history = useHistory();
  const mdRef = useRef<any>(null);
  const thinkRef = useRef<string>('');
  const textRef = useRef<any>('');
  const lang = props.lang === LanguageType.ZH ? Lang.zh_CN : Lang.en_US;
  const userInfo = useSelector((state: IRootState) => state.common.userInfo);
  const deployArea: DeployArea = getConfig()?.deployArea;
  const isWoa = deployArea === DeployArea.woa;

  const onCloseSSE = () => {
    props.onClose();
    setIsThink(false);
    const outputThinkEl = document.getElementById(
      'chat-think-output'
    ) as HTMLElement;
    const outputTextEl = document.getElementById(
      'chat-text-output'
    ) as HTMLElement;
    if (outputThinkEl?.innerHTML && thinkRef.current) {
      outputThinkEl.innerHTML = '';
      thinkRef.current = '';
    }
    if (outputTextEl?.innerHTML && textRef.current) {
      outputTextEl.innerHTML = '';
      textRef.current = '';
    }
    if (currentSSE) {
      currentSSE.close();
      setCurrentSSE(null);
    }
    if (newCurrentSSE) {
      newCurrentSSE.close();
      newCurrentSSE = null;
    }
  };
  useImperativeHandle(ref, () => ({
    onClose: () => {
      onCloseSSE();
    },
  }));

  useEffect(() => {
    segment = new Segment();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useDefault(segment);
    const markdownItWithExternalLinks = (md: any) => {
      // 保存原始的 renderer
      const defaultRender =
        md.renderer.rules.link_open ||
        function (tokens: any, idx: any, options: any, env: any, self: any) {
          return self.renderToken(tokens, idx, options);
        };

      // 重写 link_open 规则
      md.renderer.rules.link_open = function (
        tokens: any,
        idx: any,
        options: any,
        env: any,
        self: any
      ) {
        const token = tokens[idx];

        // 添加 target="_blank" 和 rel="noopener noreferrer"
        token.attrPush(['target', '_blank']);
        token.attrPush(['rel', 'noopener noreferrer']);

        // 调用原始渲染器
        return defaultRender(tokens, idx, options, env, self);
      };
    };

    mdRef.current = new (MarkdownIt as any)({
      html: false, // 禁用 HTML 标签
      linkify: false, // 禁用自动链接
      typographer: true, // 排版优化
      breaks: true,
    });
    markdownItWithExternalLinks(mdRef.current);
  }, []);

  useEffect(() => {
    let timer: NodeJS.Timeout | null = null;

    if (isThink) {
      // isThink 为 true：每 0.1 秒加 0.1
      timer = setInterval(() => {
        setTimeCount((prevTime) => prevTime + 0.1);
      }, 100); // 100ms = 0.1秒
    } else {
      // isThink 为 false：停止计时（不清零，只是停止累加）
      if (timer) {
        clearInterval(timer);
      }
    }

    // 清理函数：组件卸载或 isThink 变化时清除定时器
    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [isThink]);

  const onSelect = () => {
    setIdx((prev) => {
      console.log(prev);
      onOpen(result[prev]);
      return prev;
    });
  };

  // const debounceSearch = useCallback(
  //   debounce(async (params: IProjectDocSearch) => {
  //     setLoading(true);
  //     const res = await getProjectDocSearch(params);
  //     setLoading(false);
  //     setResult(res?.doc_list || []);
  //     setIdx(res?.doc_list?.length ? 0 : -1);
  //   }, 300),
  //   []
  // );

  const debounceSearch = useCallback(
    debounce(async (value: string) => {
      setLoading(true);
      const filteredResult: string[] = getSegmetValue(value);
      console.log('segment:', filteredResult);
      aiSearch(value);
      const results = await Promise.allSettled(
        filteredResult.map((keyword) => getProjectDocSearch(getParams(keyword)))
      );
      const successfulResults = results
        .filter(
          (
            result
          ): result is PromiseFulfilledResult<{
            doc_list: readonly IProjectSearchListItem[];
          } | null> => result?.status === 'fulfilled'
        )
        .map((result) => result.value);
      const allDocs = successfulResults
        .filter(
          (res): res is { doc_list: readonly IProjectSearchListItem[] } =>
            res !== null
        )
        .flatMap((res) => res.doc_list);

      const uniqueDocsMap = allDocs.reduce((map, doc) => {
        const { id } = doc;
        if (!map.has(id.toString())) {
          map.set(id.toString(), doc);
        }
        return map;
      }, new Map<string, IProjectSearchListItem>());

      const dedupedAndMergedDocList = Array.from(uniqueDocsMap.values());
      setLoading(false);
      setResult(dedupedAndMergedDocList || []);
      // setIdx(dedupedAndMergedDocList.length ? 0 : -1);
      // setResult(res?.doc_list || []);
      // setIdx(res?.doc_list?.length ? 0 : -1);
    }, 300),
    [userInfo, props.lang]
  );

  const getParams = (searchVal: string) => {
    return {
      keyword: searchVal,
      area: getArea(),
      proxy_doc: 1,
      projectId: `${query?.projectId}` || '',
    };
  };

  const getSegmetValue = (value: string) => {
    const result = segment
      ? segment.doSegment(value, { simple: true })
      : [value];
    const stopwords = new Set([
      '的',
      '了',
      '和',
      '是',
      '在',
      '我',
      '有',
      '与',
      '也',
      '都',
      '就',
      '要',
      '会',
      '可以',
      '一个',
      '这个',
      '那个',
      '你',
      '他',
      '她',
      '它',
      '我们',
      '他们',
      '这',
      '那',
      '这些',
      '那些',
      '之',
      '及',
      '于',
      '或',
      '而',
      '且',
      '所',
      '将',
      '为',
      '向',
      '从',
      '由',
      '到',
      '通过',
      '根据',
      '基于',
      '关于',
      '作为',
      '为了',
      '因为',
      '所以',
      '但是',
      '然后',
      '而且',
      '如果',
      '不过',
      '其实',
      '实际上',
      '以及',
      '比如',
      '例如',
      '如此',
      '这样',
      '那样',
      '如何',
      '什么',
      '为什么',
      '谁',
      '哪',
      '哪里',
      '何时',
      '多少',
      '一些',
      '任何',
      '所有',
      '每',
      '每个',
      '任何',
      '一切',
      '其他',
      '另外',
      '自己',
      '本人',
      '大家',
      '人们',
      '人类',
      '咱们',
      '你们',
      '她们',
      '它们',
      '此处',
      '这里',
      '那里',
      '当时',
      '当天',
      '现在',
      '目前',
      '今天',
      '昨天',
      '明天',
      '以后',
      '之前',
      '之后',
      '以前',
      '以后',
      '上面',
      '下面',
      '里面',
      '外面',
      '附近',
      '周围',
      '地方',
      '时间',
      '时候',
      '年',
      '月',
      '日',
      '时',
      '分',
      '秒',
      '很',
      '非常',
      '真的',
      '就',
      '也',
      '还',
      '都',
      '已经',
      '就',
      '要',
      '可以',
      '可能',
      '应该',
      '由于',
      '因为',
      '所以',
      '但是',
      '然后',
      '而且',
      '如果',
      '不过',
      '其实',
      '实际上',
      '以及',
      '比如',
      '例如',
      '如此',
      '这样',
      '那样',
      '如何',
      '什么',
      '为什么',
      '谁',
      '哪',
      '哪里',
      '何时',
      '多少',
      '一些',
      '任何',
      '所有',
      '每',
      '每个',
      '任何',
      '一切',
      '其他',
      '另外',
      '自己',
      '本人',
      '我们',
      '你们',
      '他们',
      '大家',
      '人们',
      '咱们',
      '她们',
      '它们',
      '此处',
      '这里',
      '那里',
      '当时',
      '当天',
      '现在',
      '目前',
      '今天',
      '昨天',
      '明天',
      '以后',
      '之前',
      '之后',
      '以前',
      '以后',
      '上面',
      '下面',
      '里面',
      '外面',
      '附近',
      '周围',
      '地方',
      '时间',
      '时候',
      '年',
      '月',
      '日',
      '时',
      '分',
      '秒',

      // 标点符号 / 特殊字符（中英文）
      '，',
      '。',
      '！',
      '？',
      '；',
      '：',
      '“',
      '”',
      '‘',
      '’',
      '（',
      '）',
      '【',
      '】',
      '《',
      '》',
      '、',
      '…',
      '—',
      '·',
      '「',
      '」',
      '『',
      '』',
      ',',
      '.',
      '!',
      '?',
      ';',
      ':',
      '"',
      '\'',
      '(',
      ')',
      '[',
      ']',
      '{',
      '}',
      '-',
      '_',
      '+',
      '=',
      '*',
      '/',
      '\\',
      '<',
      '>',
      '|',
      '~',
      '`',
      '@',
      '#',
      '$',
      '%',
      '^',
      '&',
      ' ',
      '\t',
      '\n',
      '\r',
      '…',
    ]);
    const filteredResult: string[] = result.filter(
      (token: any) => !stopwords.has(token)
    );
    if (!filteredResult.includes(value)) {
      filteredResult.unshift(value);
    }
    setSegmetValue(filteredResult);
    return filteredResult;
  };

  const segmentSearch = (value: string) => {
    if (!value) return;
    debounceSearch(value);
  };

  let newCurrentSSE: { close: () => void } | null = null;
  const aiSearch = async (searchVal: string) => {
    // 暂不支持英文版
    if (userInfo && searchVal && isShowAi && lang === Lang.zh_CN && isWoa) {
      setTimeCount(0);
      // 给停止按钮用
      if (currentSSE) {
        currentSSE.close();
        setCurrentSSE(null);
      }
      // 给当前方法用
      if (newCurrentSSE) {
        newCurrentSSE.close();
        newCurrentSSE = null;
      }
      setIsGenerating(true);
      setIsStop(false);
      setIsFeedback(false);
      setIsLike(false);
      setIsThink(true);
      setReferenceDoc([]);
      setIsShowThink(true);
      setShowMcp(false);

      // const outputDocEl = document.getElementById(
      //   'chat-doc-output'
      // ) as HTMLElement;
      const outputThinkEl = document.getElementById(
        'chat-think-output'
      ) as HTMLElement;
      const outputTextEl = document.getElementById(
        'chat-text-output'
      ) as HTMLElement;
      const outputThinkBodyEl = document.getElementById(
        'chat-ai-think-body'
      ) as HTMLElement;
      // if (outputDocEl?.textContent) {
      //   outputDocEl.innerHTML = '';
      // }
      if (outputThinkEl?.innerHTML && thinkRef.current) {
        outputThinkEl.innerHTML = '';
        thinkRef.current = '';
      }
      if (outputTextEl?.innerHTML && textRef.current) {
        outputTextEl.innerHTML = '';
        textRef.current = '';
      }
      if (isWoa) {
        newCurrentSSE = connectPostSSE({
          url: '/api/website/document/ai/proxy/apigw/api/v1/agents/agui/c6a7c97c2a824244a34187e9b4c84036',
          body: {
            input: {
              message: `${searchVal}  domain为${location.origin}/doc/detail/${
                lang === Lang.zh_CN ? 36 : 35
              }`,
              model: 'deepseek-v3',
              stream: true,
              temperature: 0.5,
            },
          },
          onEvent: (evt) => {
            if (evt.type === 'message') {
              if (evt.data?.type === 'THINKING_TEXT_MESSAGE_CONTENT') {
                if (outputThinkEl) {
                  thinkRef.current += evt.data?.rawEvent?.content || '';
                  const htmlContent = mdRef.current.render(thinkRef.current);
                  outputThinkEl.innerHTML = htmlContent;
                  outputThinkBodyEl.scrollTop = outputThinkBodyEl.scrollHeight;
                }
              }

              if (
                evt.data?.type === 'TOOL_CALL_START' &&
                evt.data?.toolCallName === 'use_mcp_tool'
              ) {
                setShowMcp(true);
                setIsMcpLoding(true);
              }

              if (evt.data?.type === 'TOOL_CALL_RESULT') {
                setIsMcpLoding(false);
              }

              if (evt.data?.type === 'TEXT_MESSAGE_CONTENT') {
                setIsThink(false);
                setIsShowThink(false);
                textRef.current += evt.data?.rawEvent?.content || '';
                const htmlContent = mdRef.current.render(textRef.current);
                outputTextEl.innerHTML = htmlContent;
                outputTextEl.scrollTop = outputTextEl.scrollHeight;
              }
            } else if (evt.type === 'close') {
              setIsGenerating(false);
            }
          },
        });
      } else {
        newCurrentSSE = connectPostSSE({
          url: '/api/website/document/ai/proxy/prod/bk_plugin/openapi/agent/chat_completion/',
          body: {
            chat_history: [
              {
                role: 'system',
                content:
                  '##  角色定义 你是腾讯游戏平台产品InGame的产品专家，专注于根据文档内容回答用户关于InGame平台产品能力、接入指南、控制台使用、接口/错误码查询等问题，帮助用户更好地了解和使用GCloudSDK。当给你一个关于InGame产品相关的问题时,你可以有礼貌、耐心、专业、简洁地根据 `规则要求` 中回答用户问题。## 基础说明 InGame平台全称为腾讯游戏InGame在线服务平台（Tencent Games InGame），是一款专门为游戏后端服务托管设计的平台，为游戏应用的快速开发提供了一整套在线服务解决方案。所提供的服务涵盖跨平台多人对战、社交圈互动以及长线运营分析等游戏通用能力，包含20+后台服务能力，为游戏开发者提供了极大的便利。通过使用InGame，游戏开发者可以节省大量时间和精力来构建和维护游戏后端服务，以快速、低成本提升整体游戏体验，打造全球范围内的优质多人联机游戏。   ## 规则要求 1.  在分析过程中使用的私有知识库为`InGame智能问答-中文版知识库`中的知识，知识库ID为521。2. 2.当你能够非常自信地根据私有知识可以回答用户的最新问题时才能进行回答，当你认为通过检索到知识无法准确地回答用户的最新问题时，就直接返回给用户`暂未在InGame平台文档中找到您提问的相关内容，如有需要，请联系InGame产品团队。如需了解InGame平台文档内容，请随时提问`。3. 当知识库的内容可以回答用户问题时，回答内容请以知识库原文为主，如有配图说明，请在回答中结合配图。4. 可结合游戏行业通识内理解用户问题，但不可自主创造InGame平台产品能力、数据表现等内容，请使用知识库中问题回答InGame平台相关问题。5. 可根据通识编程知识帮助用户生成InGame平台接入使用的接口的代码示例，但不可使用文档中没有提供的接口。6. 回答问题的最终结论采用结构清晰的markdown 结构。7. 请综合多篇文档内容得出全面的答案。',
              },
              {
                role: 'user',
                content: searchVal,
              },
            ],
            execute_kwargs: { stream: true },
          },
          onEvent: (evt) => {
            if (evt.type === 'message') {
              if (evt.data.event === 'think') {
                if (outputThinkEl) {
                  thinkRef.current += evt.data.content;
                  const htmlContent = mdRef.current.render(thinkRef.current);
                  outputThinkEl.innerHTML = htmlContent;
                  outputThinkBodyEl.scrollTop = outputThinkBodyEl.scrollHeight;
                }
              }

              // 忽略初始第一条 text 正在思考...  英文版也需兼容一下
              if (
                evt.data.event === 'text' &&
                evt.data.content !== '正在思考...'
              ) {
                setIsThink(false);
                setIsShowThink(false);
                textRef.current += evt.data.content;
                const htmlContent = mdRef.current.render(textRef.current);
                outputTextEl.innerHTML = htmlContent;
                outputTextEl.scrollTop = outputTextEl.scrollHeight;
              }

              if (evt.data.event === 'reference_doc') {
                // evt.data.documents && evt.data.documents.length !== 0 && evt.data.documents.forEach((item: any) => {
                //   outputDocEl.innerHTML += `<div style="margin-right: 30px;">${item?.metadata?.file_name || ''}</div>`
                // });
                setReferenceDoc(evt.data.documents);
              }

              if (evt.data.event === 'done') {
                setIsGenerating(false);
              }
            } else if (evt.type === 'hello') {
              console.log('hello event:', evt.data);
            } else if (evt.type === 'error') {
              console.error('stream error:', evt.data);
            } else if (evt.type === 'close') {
              console.log('stream closed');
            } else {
              console.log('event', evt.type, evt.data);
            }
          },
        });
      }
      setCurrentSSE(newCurrentSSE);
    }
  };

  const onKeyDown = (e: any) => {
    if (e.keyCode === 13) {
      segmentSearch(searchValue);
    }
  };

  const onChange = (e: any) => {
    const val = e.target.value.trim();
    setSearchValue(val);
    // segmentSearch(val);
  };
  const onOpen = (item: IProjectSearchListItem) => {
    if (!item) return;
    const url = `/doc/detail/${item?.project_id}${
      item?.id && +item?.id ? `/${item?.id}` : ''
    }`;
    history.push(url);
    if (isMobile()) {
      onCloseSSE();
    }
  };

  const isScroll2View = (idx: number) => {
    const el = document.querySelectorAll('.gc-search-result-item')?.[
      idx
    ] as any;
    const contentEl = document.querySelector('.gc-search-result') as any;
    if (el && contentEl) {
      const { top: elTop } = el.getBoundingClientRect();
      const { height: contentHeight, top: contentTop } =
        contentEl.getBoundingClientRect();
      if (elTop <= contentTop) {
        el.scrollIntoView();
      }
      if (elTop > contentTop + contentHeight) {
        el.scrollIntoView();
      }
    }
  };

  const onUp = () => {
    setIdx((prev) => {
      const idx = getIndex(prev - 1);
      isScroll2View(idx);
      return idx;
    });
  };

  const onDown = () => {
    setIdx((prev) => {
      const idx = getIndex(prev + 1);
      isScroll2View(idx);
      return idx;
    });
  };

  const maskSearchText = (str: string) => {
    if (!searchValue) {
      return str;
    }
    try {
      const filteredResult: string[] = Object.assign([], segmetValue);
      if (!filteredResult || filteredResult.length === 0) {
        return str;
      }
      const sortedKeywords = filteredResult
        .filter(Boolean)
        .sort((a, b) => b.length - a.length);
      let maskedStr = str;

      for (const keyword of sortedKeywords) {
        if (!keyword) continue;

        const regex = new RegExp(`(${escapeRegExp(keyword)})`, 'gi');

        maskedStr = maskedStr.replace(
          regex,
          '<span class="mask-search-value">$1</span>'
        );
      }

      return maskedStr;
    } catch (error) {
      return str;
    }
  };

  const getIndex = (index: number) => {
    let i = index;
    if (isNaN(i) || i < 0) {
      i = 0;
    }
    if (i >= result.length) {
      i = result.length - 1;
    }
    return i;
  };

  useEffect(() => {
    if (props.isOpenDrawer && props.searchValue) {
      setSearchValue(props.searchValue);
      segmentSearch(props.searchValue);
      const searchInput = document.getElementById('searchInput');
      if (searchInput) {
        searchInput.focus();
      }
      if (!visible) {
        setResult([]);
      }
      setIdx(-1);

      const styleId = 'force-enable-scroll';

      // 避免重复插入
      if (document.getElementById(styleId)) return;

      const style = document.createElement('style');
      style.id = styleId;
      style.innerHTML = `
        html, body {
          overflow-y: visible !important;
          padding-right: 0 !important;
          width: 100% !important;
        }
      `;
      document.head.appendChild(style);
    }
  }, [props.isOpenDrawer]);

  const renderSearchBar = () => {
    return (
      <div className="search-bar">
        <SpriteSvg
          width={isMobile() ? 28 : 16}
          height={isMobile() ? 28 : 16}
          type={SpriteSvgType.SearchDark}
        />
        <input
          type="text"
          onKeyDown={onKeyDown}
          placeholder={getFormatMessage('type_something_search', {}, lang)}
          onChange={onChange}
          id="searchInput"
          className="search-bar-header"
          value={searchValue}
        />
        {/* <div className="operate-text">
          <SpriteSvg width={17} height={20} type={SpriteSvgType.KeyboardUp} />
          <SpriteSvg
            className="space"
            width={17}
            height={20}
            type={SpriteSvgType.KeyboardDown}
          />
          <span>{getFormatMessage('to_navigate')}</span>
        </div> */}
      </div>
    );
  };

  const renderSearchList = () => {
    if (!loading) {
      let resultLength = 0;
      result.forEach((item) => {
        if (item.content) {
          const filteredResult: string[] = Object.assign([], segmetValue);
          const keywordContent = getKeywordContextByChars(
            item.content,
            filteredResult
          );
          if (keywordContent) {
            resultLength += 1;
          }
        }
      });
      if (resultLength) {
        return (
          <div className="gc-search-list">
            <p className="gc-search-title">
              <span>
                {getFormatMessage(
                  'search_results_total',
                  {
                    params: {
                      total: resultLength,
                    },
                  },
                  lang
                )}
              </span>
              {!isShowAi && (
                <span
                  onClick={() => {
                    setIsShowAi(true);
                    aiSearch(searchValue);
                  }}
                  className="title-ai"
                >
                  <img src={aiLogo} />
                  <span>AI问答</span>
                </span>
              )}
            </p>
            <div className="gc-search-result">
              <Navigate
                total={result.length}
                onUp={onUp}
                onDown={onDown}
                onSelect={onSelect}
              >
                {result.map((v, i: number) => {
                  return renderListItem(v, i);
                })}
              </Navigate>
            </div>
          </div>
        );
      }
      return renderEmpty();
    }
    return null;
  };

  const getKeywordContextByChars = (
    content: string,
    keywords: string[],
    beforeChars = 50,
    caseSensitive = false
  ): string => {
    if (!keywords.length) return '';
    if (!content) return '';

    // 1. 统一大小写（如果不区分大小写）
    const source = caseSensitive ? content : content.toLowerCase();

    // 2. 按顺序查找关键词第一次出现的位置（找到第一个匹配的就返回）
    let firstIndex = -1;
    // let matchedKeyword = '';

    // 按 keywords 数组顺序依次匹配，找到第一个存在的就停止
    for (let i = 0; i < keywords.length; i++) {
      const kw = caseSensitive ? keywords[i] : keywords[i].toLowerCase();
      const index = source.indexOf(kw);

      if (index !== -1) {
        // 找到第一个匹配的关键词就记录并跳出循环
        firstIndex = index;
        // matchedKeyword = keywords[i]; // 保存原始关键词（保留大小写）
        break;
      }
    }

    // 3. 如果都没找到
    if (firstIndex === -1) {
      return '';
    }

    // 4. 计算起始位置：向前取 beforeChars 个字符
    const start = Math.max(0, firstIndex - beforeChars);

    // 5. 截取片段
    let snippet = content.slice(start);

    // 6. 如果前面有截断（start > 0），加省略号
    if (start > 0) {
      snippet = `...${snippet}`;
    }

    return snippet;
  };

  const renderListItem = (v: IProjectSearchListItem, i: number) => {
    if (!v.content) return null;
    // const pValue = `${v.project_name}/${v.name}`;
    const filteredResult: string[] = Object.assign([], segmetValue);
    const keywordContent = getKeywordContextByChars(v.content, filteredResult);
    if (!keywordContent) return null;
    return (
      <NavigateItem
        key={i}
        index={i}
        selectedIndex={idx}
        className="gc-search-result-item"
      >
        <div
          ref={navigateRef}
          onClick={() => onOpen(v)}
          onMouseEnter={() => setIdx(i)}
          onMouseLeave={() => setIdx(-1)}
        >
          <h4
            dangerouslySetInnerHTML={{ __html: maskSearchText(keywordContent) }}
          ></h4>
          <p
            dangerouslySetInnerHTML={{
              __html: `${v.project_name}/${maskSearchText(v.name)}`,
            }}
          ></p>
          {/* <div className="gc-search-item-navigate">
            <SpriteSvg
              className="space"
              width={17}
              height={20}
              type={SpriteSvgType.KeyboardEnter}
            />
            <span>{getFormatMessage('to_select')}</span>
          </div> */}
        </div>
      </NavigateItem>
    );
  };

  const clickFeedback = async (val: boolean) => {
    if (isFeedback) return;
    setIsLike(val);
    setIsFeedback(true);
    const outputTextEl = document.getElementById(
      'chat-text-output'
    ) as HTMLElement;
    const body = {
      Value: {
        result: outputTextEl.textContent,
        md5: '',
        question: searchValue,
        isLike: val,
      },
    };
    await postFeedback(body);
  };

  const onCopy = async () => {
    // const combinedHtml = `${thinkRef.current} ${textRef.current}`;
    // copy(combinedHtml);
    copy(textRef.current);
    messageSuccess(getFormatMessage('copy_clipboard', {}, lang));
  };

  const renderFeedback = () => {
    return (
      <div className="footer-feedback">
        <div>您对本次回答是否满意？</div>
        <div
          className={classNames(
            'footer-feedback-item',
            isFeedback && isLike ? 'is-active-item' : '',
            isFeedback && !isLike ? 'is-disabled-item' : ''
          )}
          style={{ marginLeft: '12px', marginRight: '4px' }}
          onClick={() => clickFeedback(true)}
        >
          <span className="footer-feedback-item-span">
            <div
              className={classNames(
                'feedback-yes-img',
                isFeedback && isLike ? 'is-like' : ''
              )}
            ></div>
            <div>满意</div>
          </span>
        </div>
        <div
          className={classNames(
            'footer-feedback-item',
            isFeedback && !isLike ? 'is-active-item' : '',
            isFeedback && isLike ? 'is-disabled-item' : ''
          )}
          onClick={() => clickFeedback(false)}
        >
          <span className="footer-feedback-item-span">
            <div
              className={classNames(
                'feedback-no-img',
                isFeedback && !isLike ? 'is-not-like' : ''
              )}
            ></div>
            <div>不满意</div>
          </span>
        </div>
      </div>
    );
  };

  const renderFooterLeft = () => {
    if (isGenerating && !isStop) {
      return (
        <span
          className="footer-left-pause"
          onClick={() => {
            setIsStop(true);
            setIsGenerating(false);
            setIsThink(false);
            if (currentSSE) {
              currentSSE.close();
              setCurrentSSE(null);
              // currentSSE = null;
            }
          }}
        >
          <img src={pauseIcon} />
          <span>停止生成</span>
          <img src={loadingIcon} className="loading-icon" />
        </span>
      );
    }
    if (!isGenerating && isStop) {
      return (
        <div style={{ display: 'flex' }}>
          <div className="footer-left-generating">
            <div>已停止</div>
            <div
              className="left-generating-refrech"
              onClick={() => aiSearch(searchValue)}
            >
              <img src={refreshIcon} />
              {/* <span>重新生成</span> */}
            </div>
            <div className="left-generating-line"></div>
          </div>
          {renderFeedback()}
        </div>
      );
    }
    if (!isGenerating) {
      return renderFeedback();
    }
    return null;
  };

  const renderAiSearch = () => {
    if (!userInfo || lang !== Lang.zh_CN || !isWoa) {
      return null;
    }
    return (
      <div
        className={classNames('chat-ai-box', !isShowAi ? 'not-show-ai' : '')}
      >
        <div className="chat-ai-header">
          {isThink ? (
            <div className="chat-ai-header-think">
              <img src={loadingAi} />
              <span>思考中</span>
            </div>
          ) : (
            <div className="chat-ai-header-left">
              <img src={aiIcon} />
              <span>InGame AI助手建议</span>
            </div>
          )}
          <img
            src={hiddenAi}
            className="chat-ai-header-right"
            onClick={() => setIsShowAi(false)}
          />
        </div>
        <div className="chat-ai-think-header">
          <span>
            {referenceDoc.length !== 0 && !isGenerating && !isThink
              ? `已参考${referenceDoc.length}篇文档深度思考`
              : '正在收集资料进行思考'}
          </span>
          <span style={{ marginLeft: '2px' }}>{`${timeCount.toFixed(
            1
          )}s`}</span>
          <img
            src={downIcon}
            className={classNames(
              'chat-ai-think-header-img',
              isShowThink ? 'show-think' : ''
            )}
            onClick={() => setIsShowThink(!isShowThink)}
          />
        </div>
        <div
          id="chat-ai-think-body"
          className={classNames(
            'chat-ai-think-body',
            !isShowThink ? 'not-show-think' : ''
          )}
        >
          {referenceDoc.length !== 0 && (
            <div className="chat-doc-output-box">
              <div className="chat-doc-label">参考文档: </div>
              <div className="chat-doc-output" id="chat-doc-output">
                {referenceDoc.map((it: any) => {
                  const fileName = (it?.metadata?.file_name || '')
                    .split('/')
                    .slice(1)
                    .join('/');
                  return <div className="chat-doc-item">{fileName || ''}</div>;
                })}
              </div>
            </div>
          )}
          <div className="chat-think-output" id="chat-think-output"></div>
        </div>
        {showMcp && (
          <div className="chat-mcp-output">
            <img
              src={isMcpLoding ? loadingIcon : successIcon}
              className={isMcpLoding ? 'spin-img' : ''}
            />
            <span>调用MCP工具</span>
          </div>
        )}
        <div className="chat-text-output" id="chat-text-output"></div>
        <div className="chat-ai-footer">
          <div className="chat-ai-footer-left">{renderFooterLeft()}</div>
          <div className="chat-ai-footer-right" onClick={() => onCopy()}>
            <SvgIcon
              icon={SvgIconName.Copy}
              // className="action-icon pointer m-l"
              className="chat-ai-copy-icon"
              width={14}
              height={14}
            />
            <span>{getFormatMessage('copy', {}, lang)}</span>
          </div>
        </div>
      </div>
    );
  };

  const renderLoading = () => {
    return (
      <div className="place-state">
        {getFormatMessage('search_ellipsis', {}, lang)}
      </div>
    );
  };

  const renderEmpty = () => {
    return (
      <div className="place-state">
        {isMobile() && <img src={emptyIcon} />}
        <div className="place-state-desc">
          {getFormatMessage('no_result', {}, lang)}
        </div>
      </div>
    );
  };

  if (!visible) return null;
  return (
    <Drawer
      title={
        <div>
          <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
            <img
              src={closeIcon}
              className="sync-close-icon"
              onClick={onCloseSSE}
              style={{
                marginRight: '8px',
                width: isMobile() ? 20 : 14,
                height: isMobile() ? 20 : 14,
              }}
            />
          </div>
          {renderSearchBar()}
        </div>
      }
      placement="right"
      width={isMobile() ? '100%' : 640}
      closable={false}
      onClose={onCloseSSE}
      visible={visible}
      headerStyle={{
        position: 'sticky',
        top: 0,
        zIndex: 1,
        marginLeft: '3px',
      }}
      className="document-search-drawer"
      mask={false}
    >
      <div className="gc-search-box" onClick={(e) => e.stopPropagation()}>
        {renderAiSearch()}
        {loading && renderLoading()}
        {renderSearchList()}
      </div>
    </Drawer>
  );
  // return (
  //   <div className="gc-search-content" onClick={onMaskClick}>
  //     <div className="gc-search-box" onClick={(e) => e.stopPropagation()}>
  //       {renderSearchBar()}
  //       {loading && renderLoading()}
  //       {renderSearchList()}
  //     </div>
  //   </div>
  // );
});
